import React from 'react'

function HospitalAPITokenManagement() {
  return (
    <div> "API Tokens Management </div>
  )
}

export default HospitalAPITokenManagement